import { api } from "./client";

/** A context resolved for a company: built-in defaults overlaid with any override. */
export interface ResolvedContext {
  id: string;
  name: string;
  description: string;
  icon: string;
  color: string;
  requiredConnectors: string[];
  systemPromptFragment: string;
  rules: string[];
  isOverridden: boolean;
  updatedAt?: string;
}

export interface ListContextsResponse {
  contexts: ResolvedContext[];
}

export interface ContextResponse {
  context: ResolvedContext;
}

export const contextsApi = {
  /** GET /api/companies/:companyId/agent-contexts */
  list: (companyId: string) =>
    api.get<ListContextsResponse>(`/companies/${encodeURIComponent(companyId)}/agent-contexts`),

  /** PUT /api/companies/:companyId/agent-contexts/:contextId */
  update: (
    companyId: string,
    contextId: string,
    body: { systemPromptFragment?: string; rules?: string[] },
  ) =>
    api.put<ContextResponse>(
      `/companies/${encodeURIComponent(companyId)}/agent-contexts/${encodeURIComponent(contextId)}`,
      body,
    ),

  /** DELETE /api/companies/:companyId/agent-contexts/:contextId — reset to default */
  reset: (companyId: string, contextId: string) =>
    api.delete<ContextResponse>(
      `/companies/${encodeURIComponent(companyId)}/agent-contexts/${encodeURIComponent(contextId)}`,
    ),
};
